export interface SelectOptionsServiceGetCitiesResult {
    city: string;
    state: string;
}

export interface SelectOptionsServiceGetConnectFlowsResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetConnectFlowAudiosResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetConnectFlowQueuesResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetConnectFlowSchedulesResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetConnectFlowSurveysResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetConnectFlowCustomsResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetContactPhoneNumbersResult {
    id: number;
    number: string;
    maskedNumber: string;
}

export interface SelectOptionsServiceGetLevelsResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetMediasResult {
    label: string;
    value: string;
}

export interface SelectOptionsServiceGetNumbersResult {
    id: number;
    name: string;
    isSmartCallerId: boolean | null;
    level: {
        id: number;
        name: string;
    };
}

export interface SelectOptionsServiceGetQueuesResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetRolesResult {
    id: number;
    name: string;
}

export interface SelectOptionsServiceGetUsersResult {
    id: number;
    name: string;
    labels: Array<{
        id: number;
        label: string;
    }>;
}

export interface SelectOptionsServiceGetUserExtensionsResult {
    id: number;
    number: number;
}

export interface SelectOptionsServiceGetUserLabelsResult {
    id: number;
    label: string;
}

export interface SelectOptionsServiceGetWordsParams {
    call_participant?: string;
}

export interface SelectOptionsServiceGetWordsResult {
    id: number;
    word: string;
}
